module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAACCAYAAABYBvyLAAAAIElEQVQIW2PIyi/aCsR/qYTXM2TlFa7MzC/6RA0MMhAAPh1ZL7lzX9cAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./resources/images/minus_2x.png
// module id = 994
// module chunks = 0